import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from "@angular/forms";
import { CommonService } from "../../_services/common.service";
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { FlashMessagesService } from "angular2-flash-messages";

export interface DialogData {
  store_name: string;
}

@Component({
  selector: 'app-assign-to-store',
  templateUrl: './assign-to-store.component.html',
  styleUrls: ['./assign-to-store.component.css']
})
export class AssignToStoreComponent implements OnInit {

  storeList: Array<any> = [];
  searchTextboxControl = new FormControl();
  public isShowError = false;
  public isValueSet = false;
  public isPublicQuoteCreation = false;
  public isClientUserDetails: any = false;
  constructor(
    public dialogRef: MatDialogRef<AssignToStoreComponent>,
    private dialog: MatDialog,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router,
    private activateroute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  searchStore(event: any) {
    const filterValue = event.target.value.toLowerCase();
    this.getStoreList(filterValue);
  }

  clearSearch(event) {
    event.stopPropagation();
    this.searchTextboxControl.patchValue('');
  }

  getStoreList = function (searchText = "") {
    this.loading = true;
    this.storeItemOptions = {
      id: localStorage.getItem("userID"),
      search: searchText
    };
    this.CommonService.apiService(
      "POST",
      "stores/list",
      this.storeItemOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.storeList = response.data.records;
            if (this.isValueSet === false && this.data.store_name != '') {
              this.searchTextboxControl.patchValue(this.data.store_name);
              this.isValueSet = true;
            }
            this.isValueSet = true;
            return this.storeList;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
    return this.storeList;
  }

  assignQuoteToStore(store) {
    this.isShowError = false;
    store = store.trim();
    let storeData = this.storeList.find(x => x.name.toLowerCase() === store.toLowerCase());
    if (storeData) {
      this.dialogRef.close(storeData);
    }
    else {
      this.isShowError = true;
      this._flashMessagesService.show("please select valid store", {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/assign-to-store/assign-to-store.component.ts